import React from "react";
import { SimpleForm, required, useQuery } from "react-admin";
import FileInput from "./inputs/FileInput";
import MediaTypeInput from "./inputs/MediaTypeInput";
import { get } from "lodash";
import { Toolbar } from "ra-friendsofbabba";

const Form = (props) => {
  const { record } = props;
  const { data } = useQuery({
    type: "get",
    resource: "projects/state",
    payload: {
      id: record?.project_id,
    },
  });
  const state = get(data, "data.state");

  return (
    <SimpleForm
      {...props}
      initialValues={{
        ...record,
        media_type:
          state !== "draft" && state !== "integrations_requested"
            ? "post"
            : "pre",
      }}
      toolbar={
        <Toolbar
          backTab={4}
          backReferenceTarget="project_id"
          backReference="projects"
        />
      }
    >
      <MediaTypeInput source="media_type" />
      <FileInput source="media_collection" validate={required()} />
    </SimpleForm>
  );
};
export default Form;
